import { api } from "../api";
import { ValidateEmail } from "@/api/forms";
import { LOGIN_STEPS } from "@/forms/service/auth";

export const EBOOK_STEPS = {
  DOWNLOAD_STEP: "DOWNLOAD_STEP"
};
export const validateEmail = async (data: ValidateEmail) => {
  const { data: validateData } = await api.forms.validateEmail({
    ...data,
    _login: 1
  });

  if (!validateData.success) {
    throw new Error();
  }

  if (!validateData.is_verified_email) {
    return { next: LOGIN_STEPS.VERIFY_STEP, data: validateData };
  }

  if (validateData.otp && validateData.otp.required) {
    return {
      next: LOGIN_STEPS.ONE_TIME_PASSWORD_STEP,
      data: validateData
    };
  }

  return {
    next: LOGIN_STEPS.REDIRECT_STEP,
    data: validateData
  };
};

export const getUserStatus = async (data: any) => {
  const { data: response } = await api.forms.getUserStatus(data);

  return response;
};

export const downloadEbook = async (data: any) => {
  const { data: response } = await api.forms.downloadEbook(data);

  if (response.error || !response.success) {
    throw { error: response.error };
  }

  return {
    data: response
  };
};
